import { render, staticRenderFns } from "./engaged.vue?vue&type=template&id=5c201aa3&scoped=true&"
import script from "./engaged.vue?vue&type=script&lang=js&"
export * from "./engaged.vue?vue&type=script&lang=js&"
import style0 from "./engaged.vue?vue&type=style&index=0&id=5c201aa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c201aa3",
  null
  
)

export default component.exports